import { render, staticRenderFns } from "./VariantPicker.vue?vue&type=template&id=08f01aaa"
import script from "./VariantPicker.vue?vue&type=script&lang=ts"
export * from "./VariantPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports